import { useEffect, useRef } from 'react';

import { useNavigationContext } from '../context/NavigationContext';

export const useAutoExpand = (hasActiveChildren: boolean, isExpanded: boolean, itemText: string) => {
  const { isNavCollapsed, toggleSection } = useNavigationContext();
  const prevIsNavCollapsed = useRef(isNavCollapsed);

  useEffect(() => {
    const wasCollapsed = prevIsNavCollapsed.current;
    const isNowExpanded = !isNavCollapsed;

    if (wasCollapsed && isNowExpanded && hasActiveChildren && !isExpanded) {
      toggleSection(itemText);
    }

    prevIsNavCollapsed.current = isNavCollapsed;
  }, [isNavCollapsed, hasActiveChildren, isExpanded, itemText, toggleSection]);
};
